import { apiClient, toCamelCase, toSnakeCase } from "./client";
import type { Category, CategoryCreate, CategoryUpdate, CategoryListResponse } from "@/types";

export const categoriesApi = {
  getAll: async (search?: string): Promise<CategoryListResponse> => {
    const response = await apiClient.get("/categories", {
      params: search ? { search } : undefined,
    });
    return (toCamelCase(response.data) as CategoryListResponse) || { items: [], total: 0 };
  },

  getById: async (id: number): Promise<Category> => {
    const response = await apiClient.get(`/categories/${id}`);
    return toCamelCase(response.data) as Category;
  },

  create: async (data: CategoryCreate): Promise<Category> => {
    const response = await apiClient.post("/categories", toSnakeCase(data));
    return toCamelCase(response.data) as Category;
  },

  update: async (id: number, data: CategoryUpdate): Promise<Category> => {
    const response = await apiClient.put(`/categories/${id}`, toSnakeCase(data));
    return toCamelCase(response.data) as Category;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/categories/${id}`);
  },
};
